import * as React from "react";
const SvgFiRrVoicemail = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M18.5 6a5.506 5.506 0 0 0-5.5 5.5c0 1.328.474 2.548 1.261 3.5H9.74A5.48 5.48 0 0 0 11 11.5C11 8.467 8.533 6 5.5 6A5.506 5.506 0 0 0 0 11.5C0 14.533 2.467 17 5.5 17h13c3.032 0 5.5-2.467 5.5-5.5S21.532 6 18.5 6M2 11.5C2 9.57 3.57 8 5.5 8S9 9.57 9 11.5 7.43 15 5.5 15 2 13.43 2 11.5M18.5 15c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15"
    />
  </svg>
);
export default SvgFiRrVoicemail;
